"use strict";
/**
 * Regular expression.
 * @module @fe/utils/lib/regex/exp

 * @description support server & client & miniprogram side
 * @see https://gitlab.cdfsunrise.com/frontend/core/-/tree/main/packages/utils
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.URL = exports.HAN = exports.MOBILE_TAIWAN = exports.MOBILE_MACAU = exports.MOBILE_HONGKONG = exports.MOBILE = exports.PASSPORTCARD_TAIWAN = exports.PASSPORTCARD_HONGKONG_MACAU = exports.PASSPORTCARD = exports.IDCARD_OFFICER = exports.IDCARD = exports.TEL = exports.QQ = exports.DATE = exports.EMAIL = void 0;
exports.EMAIL = /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/; //邮件
exports.DATE = /^\d{4}(\-|\/|.)\d{1,2}\1\d{1,2}$/; // 日期
exports.QQ = /^[1-9]*[1-9][0-9]*$/; // QQ号码
exports.TEL = /^(([0\+]\d{2,3}-)?(0\d{2,3})-)?(\d{7,8})(-(\d{3,}))?$/; //电话号码的函数(包括验证国内区号,国际区号,分机号)
exports.IDCARD = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/; // 身份证
exports.IDCARD_OFFICER = /^[\u4E00-\u9FA5](字第)([0-9a-zA-Z]{4,8})(号?)$/; // 军官证：军字第2001988号, 士字第P011816X号
exports.PASSPORTCARD = /^([a-zA-z]|[0-9]){5,17}$/; // 护照：141234567, G12345678, P1234567
exports.PASSPORTCARD_HONGKONG_MACAU = /^([A-Z]\d{6,10}(\(\w{1}\))?)$/; // 港澳通行证：H1234567890
exports.PASSPORTCARD_TAIWAN = /^\d{8}|^[a-zA-Z0-9]{10}|^\d{18}$/; // 台湾通行证：12345678 或 1234567890B
exports.MOBILE = /^((\+?86)|(\(\+86\)))?1[3456789]{1}\d{9}$/; // 大陆手机
exports.MOBILE_HONGKONG = /^((\+?852)|(\(\+852\)))?[5689]{1}\d{7}$/; //香港手机
exports.MOBILE_MACAU = /^((\+?853)|(\(\+853\)))?[6]{1}[68]{1}\d{5}$/; //澳门手机
exports.MOBILE_TAIWAN = /^((\+?886)|(\(\+866\)))?[0]{1}[9]{1}\d{8}$/; //台湾手机
exports.HAN = /^[\u4e00-\u9fa5]+$/; //中文
exports.URL = /^((http|ftp|https):\/\/(([a-zA-Z0-9]+-?)+[a-zA-Z0-9]+\.)+[a-zA-Z]+)(:\d+)?(\/.*)?(\?.*)?(#.*)?$/; // URL
// ip regex
// @see https://github.com/sindresorhus/ip-regex
// 国际化正则
// @see https://github.com/validatorjs/validator.js
//# sourceMappingURL=exp.js.map